import { API_URLs } from "../../../../utilities/API_URLs"
import iAxios from "../../../../utilities/axios/axios-setup"
import { Http } from "../../../../utilities/axios/http"
import { StoreStoragePageState, NewStoreStorageRequest } from "./_model"
// import { NewRoleData, UserRolePageState } from "./_model"

/* export const postNewStoreStorage = (data: NewStoreStorageRequest) => {
  return iAxios.post(API_URLs.settings.storeStorage.postStoreStorage, data)
  .then(r => {
    return r.data
  })
  .catch(e => {
    return null
  })
}

export const getStoreStorageList = (pageState: StoreStoragePageState) => {
  const obj: any = {...pageState}
  Object.keys(pageState).forEach((key: any) => {
    if (key === 'order') {
      console.log('The order key ')
      obj['order[' + (pageState?.order?.dataKey ?? '') + ']'] = pageState?.order?.order;
    } else {
      obj[key] = obj[key]?.toString()
    }
    
  })
  delete obj['order']
  return iAxios.get(API_URLs.settings.storeStorage.getStoreStorages + '?' + new URLSearchParams(obj) )
  .then(r => {
    return r?.data
  })
  .catch(e => {
    return null
  })
}

export const getMagasinById = (id: string) => {
  return iAxios.get(API_URLs.settings.storeStorage.getStoreStorageById?.replace('{id}', id))
  .then(r => r.data)
  .catch(e => null)
}

export const patchMagasinById = (id: string, data: NewStoreStorageRequest) => {
  return iAxios.patch(API_URLs.settings.storeStorage.patchStoreStorageById?.replace('{id}', id), {...data, id}, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
    }
  })
  .then(r => {
    return r.data
  })
  .catch(e => {
    return null
  })
}

export const deleteMagasinById = (id: string) => {
  return iAxios.delete(API_URLs.settings.storeStorage.deleteStoreStorageById?.replace('{id}', id))
  .then(r => ({success: true, data: r.data}))
  .catch(e => null)
} */

export class StoreStorageService {
  static postStoreStorage = async (data: any) => {
    try {
      return await Http.post(API_URLs.settings.storeStorage.storeStorageUrl, data);
    } catch (error) {
      return error
    }
  }

  static getStoreStorage = async (id: number) => {
    try {
      return await Http.get(`${API_URLs.settings.storeStorage.storeStorageUrl}/${id}`);
    } catch (error) {
      return error
    }
  }

  static getStoreStorageList = async (params?: any) => {
    try {
      return await Http.get(API_URLs.settings.storeStorage.storeStorageUrl, params)
    } catch (error) {
      return error;
    }
  }

  static patchStoreStorage = async (data: any) => {
    try {
      return await Http.patch(API_URLs.settings.storeStorage.storeStorageUrl, data);
    } catch (error) {
      return error;
    }
  }

  static deleteStoreStorage = async (id: number) => {
    try {
      return await Http.delete(`${API_URLs.settings.storeStorage.storeStorageUrl}/${id}`);
    } catch (error) {
      return error;
    }
  }
}